import { MensagemErroModel } from './../../../../shared/model/mensagem-erro.model';

export class DadosOnInitModelView{
  ListaAno: Ano[];
  ListaTipoReceita: TipoReceita[];
  objetoMensagem: MensagemErroModel;
}

export class DistribuicaoMensalMunicipioFiltro{
  IdAno: string;
  IdMes: string;
  DescricaoMes : string;
  IdTipoReceita: string;
  DescricaoTipoReceita: string;
}

export class DistribuicaoMensalMunicipioEntidade{
  DescricaoMunicipio: string;
  ValorCreditadoIcms: number;
  ValorCreditadoIpi: number;
  ValorCreditadoipva: number;
  ValorCreditadoFies: number;
  ValorCreditadoFcba: number;
  ValorAcumuladoIcms: number;
  ValorAcumuladoIpi: number;
  ValorAcumuladoIpva: number;
  ValorAcumuladoFies: number;
  ValorAcumuladoFcba : number;
}

export class Ano{
  IdAno: string;
  Descricao: string;
}

export class Mes{
  IdMes: string;
  Descricao: string;
}

export class TipoReceita{
  IdTipoReceita: string;
  Descricao: string;
}

export class DistribuicaoMensalMunicipioModelView{
  ListaDistribuicaoMensalMunicipio : DistribuicaoMensalMunicipioEntidade[];
  objetoMensagem: MensagemErroModel;
}



// WEBPACK FOOTER //
// ./src/app/consulta/distribuicao-mensal-aos-municipio/shared/model/distribuicaoMensalMunicipio.model.ts